/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, mediaQuery } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- ADD-ON TYPES COMMENTS COUNTER LABEL: STYLES --------------- ++++++++++ */
export default theme => ({
    commentscountlabel: {
        marginTop: pxToEm(16),
        '& .fields': {
            display: 'inline-flex',
            '& .fielditem': {
                marginRight: pxToEm(8),
                '& label': {
                    display: 'flex',
                    height: pxToEm(24),
                    lineHeight: pxToEm(24),
                    fontSize: pxToEm(14)
                },
                '& .field': {
                    marginTop: pxToEm(8),
                    width: '100%'
                }
            }
        }
    },
    
    // ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
    [mediaQuery.thinnest]: {
      commentscountlabel: {
        '& .fields': {
            width: '100%',
            flexDirection: 'column',
            '& .fielditem': {
                paddingBottom: pxToEm(16)
            }
        }
      }
    }
});
